/* Dummy data for the /draw-lab receipt draw experiment. Nothing here touches the API. */

export const LAB_TOTAL_RECEIPTS = 12483;

export const LAB_TIERS = [
  { tier_level: 1, prize_amount: 200 },
  { tier_level: 2, prize_amount: 500 },
  { tier_level: 3, prize_amount: 2000 },
];

const PEOPLE = [
  ["Arbër", "Krasniqi"],
  ["Drita", "Berisha"],
  ["Luan", "Gashi"],
  ["Vjosa", "Hoxha"],
  ["Blerim", "Shala"],
  ["Teuta", "Morina"],
  ["Ilir", "Kelmendi"],
  ["Mimoza", "Rexhepi"],
  ["Gent", "Bytyqi"],
  ["Rina", "Osmani"],
  ["Faton", "Zeqiri"],
  ["Elira", "Maloku"],
];

const BUSINESSES = [
  ["811234567", "Market Rugova SH.P.K.", "Pejë"],
  ["810998231", "Furra Dardania", "Prishtinë"],
  ["812450019", "Kafe Prishtina Center", "Prishtinë"],
  ["811773405", "Farmacia Shëndeti", "Prizren"],
  ["810336782", "Auto Servis Drini", "Gjakovë"],
  ["812901144", "Libraria Dituria", "Mitrovicë"],
  ["811560328", "Supermarketi Viva", "Ferizaj"],
];

const ITEMS = [
  ["Bukë e bardhë", 0.6],
  ["Qumësht 1L", 0.95],
  ["Djathë i bardhë", 4.2],
  ["Kafe espresso", 1.0],
  ["Ujë mineral", 0.5],
  ["Vezë x10", 2.3],
  ["Mollë 1kg", 1.1],
  ["Vaj ulliri", 7.9],
  ["Makarona", 1.25],
  ["Çokollatë", 1.6],
  ["Detergjent", 5.4],
  ["Sapun", 0.9],
];

const rand = (n) => Math.floor(Math.random() * n);
const shuffled = (arr) => [...arr].sort(() => Math.random() - 0.5);

const fakeItems = () =>
  shuffled(ITEMS)
    .slice(0, 3 + rand(3))
    .map(([name, price]) => ({ name, qty: 1 + rand(3), price }));

const fakeDate = () => {
  const d = new Date(Date.now() - rand(20) * 86400000 - rand(10 * 3600) * 1000);
  return d.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/* Shaped like a generate-winners row, plus the receipt details the stage prints */
export const buildLabWinners = (count, tier = LAB_TIERS[0]) =>
  shuffled(PEOPLE)
    .slice(0, count)
    .map(([first_name, last_name]) => {
      const [business_nui, business_name, business_city] = BUSINESSES[rand(BUSINESSES.length)];
      const items = fakeItems();
      const total = items.reduce((sum, i) => sum + i.qty * i.price, 0);
      return {
        receipt_id: 300 + rand(9700),
        user_id: 100 + rand(900),
        first_name,
        last_name,
        business_nui,
        business_name,
        business_city,
        receipt_date: fakeDate(),
        items,
        total: total.toFixed(2),
        tier_level: tier.tier_level,
        prize_amount: tier.prize_amount,
      };
    });

export const LAB_BUSINESS_PRIZE = 100;

/* The businesses behind the winning receipts, once each — like the backend's
   business_winners (it also skips businesses it can't verify, so some go missing) */
export const buildLabBusinessWinners = (winners) => {
  const seen = new Set();
  return winners
    .filter((w) => {
      if (seen.has(w.business_nui) || Math.random() < 0.15) return false;
      seen.add(w.business_nui);
      return true;
    })
    .map((w) => ({
      receipt_id: w.receipt_id,
      business_nui: w.business_nui,
      business_name: w.business_name,
      prize_amount: LAB_BUSINESS_PRIZE,
    }));
};
